export const TKeyOffer = {
  OFFERS_NAV: "OFFERS_NAV",
  OFFERS_SEO_TITLE: "OFFERS_SEO_TITLE",
  OFFERS_TITLE: "OFFERS_TITLE",
  OFFERS_SUBTITLE: "OFFERS_SUBTITLE",
  OFFERS_META_DESCRIPTION: "OFFERS_META_DESCRIPTION",
  OFFERS_EXTRACT_TITLE: "OFFERS_EXTRACT_TITLE",
  OFFERS_EXTRACT_BADGE: "OFFERS_EXTRACT_BADGE",
  OFFERS_EXTRACT_DESCRIPTION: "OFFERS_EXTRACT_DESCRIPTION",
  OFFERS_EXTRACT_BENEFIT_1: "OFFERS_EXTRACT_BENEFIT_1",
  OFFERS_EXTRACT_BENEFIT_2: "OFFERS_EXTRACT_BENEFIT_2",
  OFFERS_EXTRACT_BENEFIT_3: "OFFERS_EXTRACT_BENEFIT_3",
  OFFERS_EXTRACT_CTA: "OFFERS_EXTRACT_CTA",
  OFFERS_EXTRACT_MODAL_LEAD: "OFFERS_EXTRACT_MODAL_LEAD",
  OFFERS_EXTRACT_EXISTING_NOTE: "OFFERS_EXTRACT_EXISTING_NOTE",
  OFFERS_EXTRACT_NO_CALLS: "OFFERS_EXTRACT_NO_CALLS",
  OFFERS_EXTRACT_NO_CALLS_LINK: "OFFERS_EXTRACT_NO_CALLS_LINK",
  OFFERS_EXTRACTING: "OFFERS_EXTRACTING",
  OFFER_ADD_CHOICE_EXTRACT_TITLE: "OFFER_ADD_CHOICE_EXTRACT_TITLE",
  OFFER_ADD_CHOICE_EXTRACT_FLOW: "OFFER_ADD_CHOICE_EXTRACT_FLOW",
  OFFER_ADD_CHOICE_EXTRACT_LOCKED: "OFFER_ADD_CHOICE_EXTRACT_LOCKED",
  OFFER_ADD_CHOICE_MANUAL_TITLE: "OFFER_ADD_CHOICE_MANUAL_TITLE",
  OFFER_ADD_CHOICE_MANUAL_FLOW: "OFFER_ADD_CHOICE_MANUAL_FLOW",
  OFFERS_GENERATE_TITLE: "OFFERS_GENERATE_TITLE",
  OFFERS_GENERATE_BADGE: "OFFERS_GENERATE_BADGE",
  OFFERS_GENERATE_DESCRIPTION: "OFFERS_GENERATE_DESCRIPTION",
  OFFERS_GENERATE_BENEFIT_1: "OFFERS_GENERATE_BENEFIT_1",
  OFFERS_GENERATE_BENEFIT_2: "OFFERS_GENERATE_BENEFIT_2",
  OFFERS_GENERATE_BENEFIT_3: "OFFERS_GENERATE_BENEFIT_3",
  OFFERS_GENERATE_CTA: "OFFERS_GENERATE_CTA",
  OFFERS_NEXT_AVATAR_TITLE: "OFFERS_NEXT_AVATAR_TITLE",
  OFFERS_NEXT_AVATAR_DESCRIPTION: "OFFERS_NEXT_AVATAR_DESCRIPTION",
  OFFERS_NEXT_AVATAR_CTA: "OFFERS_NEXT_AVATAR_CTA",
  OFFER_NAME_LABEL: "OFFER_NAME_LABEL",
  OFFER_NAME_PLACEHOLDER: "OFFER_NAME_PLACEHOLDER",
  OFFER_TYPE_LABEL: "OFFER_TYPE_LABEL",
  OFFER_TYPE_PLACEHOLDER: "OFFER_TYPE_PLACEHOLDER",
  OFFER_PROBLEM_LABEL: "OFFER_PROBLEM_LABEL",
  OFFER_PROBLEM_PLACEHOLDER: "OFFER_PROBLEM_PLACEHOLDER",
  OFFER_PROMISE_LABEL: "OFFER_PROMISE_LABEL",
  OFFER_PROMISE_PLACEHOLDER: "OFFER_PROMISE_PLACEHOLDER",
  OFFER_KEY_ADVANTAGES_LABEL: "OFFER_KEY_ADVANTAGES_LABEL",
  OFFER_KEY_ADVANTAGES_PLACEHOLDER: "OFFER_KEY_ADVANTAGES_PLACEHOLDER",
  OFFER_KEY_ADVANTAGES_ADD: "OFFER_KEY_ADVANTAGES_ADD",
  OFFER_PROOF_LABEL: "OFFER_PROOF_LABEL",
  OFFER_PROOF_PLACEHOLDER: "OFFER_PROOF_PLACEHOLDER",
  OFFER_PROOF_ADD: "OFFER_PROOF_ADD",
  OFFER_PRICE_LABEL: "OFFER_PRICE_LABEL",
  OFFER_PRICE_PLACEHOLDER: "OFFER_PRICE_PLACEHOLDER",
  OFFER_CREATE_BUTTON: "OFFER_CREATE_BUTTON",
  OFFER_DELETE_TITLE: "OFFER_DELETE_TITLE",
  OFFER_DELETE_WARNING: "OFFER_DELETE_WARNING",
  OFFER_DELETE_CONFIRM: "OFFER_DELETE_CONFIRM",
} as const;
